<canvas
  baseChart
  [datasets]="chartData"
  [options]="chartOptions"
></canvas>
<div class="label">{{ label }}</div>
